import ArticleDetail from './article-detail'
export default [
  {
    path: '/articleDetail',
    name: 'article-detail',
    component: ArticleDetail
  }
]



// WEBPACK FOOTER //
// ./src/components/article-detail/article-detail-router.js